import { caSpriteAttributes } from "./lib/ca-sprite-attributes"
const BrowserSprite = require("svg-baker-runtime/src/browser-sprite").default
import domready from "domready"

/**
 * The svg-sprite-loader doesn't allow us to customise attributes
 * on the spritesheet, without providing an entirely custom sprite
 * runtime.
 *
 * This file is based on https://github.com/JetBrains/svg-sprite-loader/blob/master/runtime/browser-sprite.js
 * but customised with the accessibility attributes we need.
 *
 * See https://github.com/kisenka/svg-sprite-loader/issues/200 for an issue
 * that may lead to a way to add these attributes without a custom sprite
 * runtime in future.
 */

//
// The only thing below here that we change is the spreading `caSpriteAttributes`
// into the attribute property in the BrowserSprite constructor.
// Everything else is copy/pasted, plus a few typescript hints.
//

const spriteNodeId = "__SVG_SPRITE_NODE__"
const spriteGlobalVarName = "__SVG_SPRITE__"

/**
 * @typedef { (existingElement: HTMLElement) => void } AttachFn
 * @typedef { (target: HTMLElement, prepend: boolean) => void } MountFn
 * @typedef { { attach: AttachFn, mount: MountFn } } BrowserSprite
 */

/** @type { typeof window & { ["__SVG_SPRITE__"]: BrowserSprite } } */
// @ts-ignore
const win = window

const isSpriteExists = !!win[spriteGlobalVarName]

/** @type { BrowserSprite } */
// eslint-disable-next-line import/no-mutable-exports
let sprite

if (isSpriteExists) {
  sprite = win[spriteGlobalVarName]
} else {
  sprite = new BrowserSprite({
    attrs: { id: spriteNodeId, ...caSpriteAttributes },
  })
  win[spriteGlobalVarName] = sprite
}

const loadSprite = () => {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  const existing = document.getElementById(spriteNodeId)

  if (existing) {
    sprite.attach(existing)
  } else {
    sprite.mount(document.body, true)
  }
}

if (document.body) {
  loadSprite()
} else {
  domready(loadSprite)
}

export default sprite
